import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DOMAIN_APP_REDIRECTOR } from 'Constants/index'

const useRedirectorUrl = () => {
  const [redirectUrl, setRedirectUrl] = useState(false)
  const { pathname, search } = useLocation()

  useEffect(() => {
    setRedirectUrl(DOMAIN_APP_REDIRECTOR + pathname + search)
  }, [pathname, search])

  return [redirectUrl]
}

export default useRedirectorUrl
